import { getRuntimeTheme } from './runtimeEnv'

const THEME = getRuntimeTheme()

const defaultPirTerminology = {
  associationTerm: 'strata',
  requestName: 'Property Information Request',
  requestShortName: 'PIR'
}

const saskatoonPirTerminology = {
  associationTerm: 'condominium',
  requestName: 'Building Permit Drawing Package Request',
  requestShortName: 'Building Permit Drawing Package Request'
}

const inactivePirConfig = {
  active: false,
  terminology: { ...defaultPirTerminology },
  paymentEnabled: true,
  province: '',
  supportEmail: '',
  supportPhone: '',
  ownerAuthForm: '',
  disclaimer: '',
  gis: {
    ownerVerification: false,
    addressVerification: false,
    strataVerification: false
  }
}

const inactiveFoiConfig = {
  active: false,
  privacyTeamNumber: '',
  privacyTeamEmail: '',
  address: '',
  APPLICATION_FEE: true,
  applicationFeeAmount: 10,
  bill: {
    percentDue: {
      APPLICATION_FEE: 100,
      FEE_ESTIMATE: 50,
      INVOICE: 100
    }
  },
  request: {
    addressAuthConfig: '',
    generalAuthConfig: '',
    accessMethod: {
      digitalLabel: '',
      physicalLabel: '',
      otherActiveType: null
    },
    disclaimer: ''
  }
}

const citadelConfig = {
  supportPortal: true,
  showContact: false,
  city: 'Kelowna',
  pir: {
    active: true,
    terminology: { ...defaultPirTerminology },
    paymentEnabled: true,
    fullName: 'Demo',
    province: 'BC',
    supportEmail: 'pir@citadel.ca',
    supportPhone: '(250)-111-2222',
    ownerAuthForm: 'https://www.kelowna.ca/sites/files/1/docs/homes-building/owners_authorization_2020.pdf',
    disclaimer: `A property information request is a process to provide copies of City documents and plans
    from the Building & Permitting branch regarding a specific property or properties.
    The City does not guarantee the availability of information for all files. <br/> 
    The City endeavours to provide accurate information for the property file search in a timely manner,
    and ensures the privacy of property owners is protected and copyright regulations are followed. <br/>
    Citadel does not warranty the accuracy or completeness of this information
    and no representations are being made by providing this copy.
    Reliance on this information will be solely at your own risk and not that of the City.
    This information has been provided subject to the Federal Copyright Act
    and in accordance with the Freedom of Information and Protection of Privacy Act.`,
    gis: {
      ownerVerification: true,
      addressVerification: true,
      strataVerification: false
    }
  },
  foi: {
    active: true,
    privacyTeamNumber: '(250) 111-2222',
    privacyTeamEmail: 'foi@citadel.ca',
    address: 'City Hall\n7 Victoria St W\nKamloops, BC\nV2C 1A2',
    APPLICATION_FEE: true,
    applicationFeeAmount: 10,
    bill: {
      percentDue: {
        APPLICATION_FEE: 100,
        FEE_ESTIMATE: 50,
        INVOICE: 100
      }
    },
    request: {
      addressAuthConfig: '',
      generalAuthConfig:
        'https://www.kamloops.ca/sites/default/files/2023-08/258567_FOI%20Release%20of%20Information%20%28Including%20KFR%29%20Fillable_Aug3.pdf',
      accessMethod: {
        digitalLabel: '($0.10/page)',
        physicalLabel: '($0.25/page)',
        otherActiveType: null
      },
      disclaimer: `Personal information is collected for the purposes of processing your request for records.
      The City is collecting this information under Section 26(c) of the Freedom of Information and
      Protection of Privacy Act. For questions regarding the collection of personal information on this
      form, please contact the Information and Privacy Team at foi@citadel.ca or (250) 111-2222.`
    }
  }
}

const citadelpirConfig = {
  ...citadelConfig,
  foi: {
    ...citadelConfig.foi,
    active: false
  }
}

const citadelfoiConfig = {
  ...citadelConfig,
  pir: {
    ...citadelConfig.pir,
    active: false
  }
}

const kelownaConfig = {
  supportPortal: false,
  showContact: false,
  city: 'Kelowna',
  pir: {
    active: true,
    terminology: { ...defaultPirTerminology },
    paymentEnabled: true,
    fullName: 'Kelowna',
    province: 'BC',
    supportEmail: 'pir@kelowna.ca',
    supportPhone: '(250) 469-8960',
    ownerAuthForm: 'https://www.kelowna.ca/sites/files/1/docs/homes-building/owners_authorization_2020.pdf',
    disclaimer: `A property information request is a process to provide copies of City documents and plans
    from the Building & Permitting branch regarding a specific property or properties.
    The City does not guarantee the availability of information for all files. <br/> 
    The City endeavours to provide accurate information for the property file search in a timely manner,
    and ensures the privacy of property owners is protected and copyright regulations are followed. <br/>
    The City of Kelowna does not warranty the accuracy or completeness of this information
    and no representations are being made by providing this copy.
    Reliance on this information will be solely at your own risk and not that of the City.
    This information has been provided subject to the Federal Copyright Act
    and in accordance with the Freedom of Information and Protection of Privacy Act.`,
    gis: {
      ownerVerification: true,
      addressVerification: true,
      strataVerification: true
    }
  },
  foi: { ...inactiveFoiConfig }
}

const kamloopsConfig = {
  supportPortal: true,
  showContact: false,
  city: 'Kamloops',
  pir: { ...inactivePirConfig },
  foi: {
    active: true,
    privacyTeamNumber: '(250) 828-3766',
    privacyTeamEmail: 'foi@kamloops.ca',
    address: 'City Hall\n7 Victoria St W\nKamloops, BC\nV2C 1A2',
    APPLICATION_FEE: false,
    applicationFeeAmount: 10,
    bill: {
      percentDue: {
        APPLICATION_FEE: 100,
        FEE_ESTIMATE: 50,
        INVOICE: 100
      }
    },
    request: {
      addressAuthConfig: '',
      generalAuthConfig:
        'https://www.kamloops.ca/sites/default/files/2023-08/258567_FOI%20Release%20of%20Information%20%28Including%20KFR%29%20Fillable_Aug3.pdf',
      accessMethod: {
        digitalLabel: '($0.10/page)',
        physicalLabel: '($0.25/page)',
        otherActiveType: null
      },
      disclaimer: `Personal information is collected for the purposes of processing your request for records.
      The City is collecting this information under Section 26(c) of the Freedom of Information and
      Protection of Privacy Act. For questions regarding the collection of personal information on this
      form, please contact the Information and Privacy Team at foi@kamloops.ca or (250) 828-3766.`
    }
  }
}

const princegeorgeConfig = {
  supportPortal: false,
  showContact: false,
  city: 'Prince George',
  pir: { ...inactivePirConfig },
  foi: {
    active: true,
    privacyTeamNumber: '',
    privacyTeamEmail: 'foirequests@princegeorge.ca',
    address: 'City Hall\n1100 Patricia Blvd\nPrince George, BC\nV2L 3V9',
    APPLICATION_FEE: false,
    applicationFeeAmount: 10,
    bill: {
      percentDue: {
        APPLICATION_FEE: 100,
        FEE_ESTIMATE: 50,
        INVOICE: 100
      }
    },
    request: {
      addressAuthConfig: '',
      generalAuthConfig: 'https://www.princegeorge.ca/media/1392',
      accessMethod: {
        digitalLabel: '',
        physicalLabel: '',
        otherActiveType: null
      },
      disclaimer: `Personal information is collected for the purposes of processing your request for records.
      The City is collecting this information under Section 26(c) of the Freedom of Information and
      Protection of Privacy Act. For questions regarding the collection of personal information on this
      form, please contact the Information and Privacy Team at foirequests@princegeorge.ca.`
    }
  }
}

const pittmeadowsConfig = {
  supportPortal: false,
  showContact: false,
  city: 'Pitt Meadows',
  pir: {
    active: true,
    terminology: { ...defaultPirTerminology },
    paymentEnabled: true,
    province: 'BC',
    supportEmail: 'building@pittmeadows.ca',
    supportPhone: '(604) 465-2428 (ext. 1)',
    ownerAuthForm: 'https://www.pittmeadows.ca/sites/default/files/docs/letter_of_authorization_0.pdf',
    disclaimer: `A property information request is a process to provide copies of City documents and plans from the 
    Building & Permitting branch regarding a specific property or properties. <br/> The City does not guarantee the availability 
    of information for all files. The City endeavours to provide accurate information for the property file search in a 
    timely manner, and ensures the privacy of property owners is protected and copyright regulations are followed. <br/>
    The City of Pitt Meadows does not warranty the accuracy or completeness of this information and no representations are 
    being made by providing this copy. Reliance on this information will be solely at your own risk and not that of the City. 
    This information has been provided subject to the Federal Copyright Act and in accordance with the Freedom of Information 
    and Protection of Privacy Act. <br/> This collection of personal information is authorized under s. 26(c) of the Freedom 
    of Information and Protection of Privacy Act. The information will be used to process property information requests and 
    other related tasks. Questions regarding the collection of your personal information can be directed to: Privacy Officer, 
    (604) 465-5454, clerks@pittmeadows.ca.`,
    gis: {
      ownerVerification: false,
      addressVerification: false,
      strataVerification: false
    }
  },
  foi: { ...inactiveFoiConfig }
}

const pittmeadowsfoiConfig = {
  supportPortal: false,
  showContact: false,
  city: 'Pitt Meadows',
  pir: { ...inactivePirConfig },
  foi: {
    active: true,
    privacyTeamNumber: '(604) 465-5454',
    privacyTeamEmail: 'clerks@pittmeadows.ca',
    address: 'City Hall\n11001 Harris Road\nPitt Meadows, BC\nV3Y 1P9',
    APPLICATION_FEE: true,
    applicationFeeAmount: 10,
    bill: {
      percentDue: {
        APPLICATION_FEE: 100,
        FEE_ESTIMATE: 50,
        INVOICE: 100
      }
    },
    request: {
      addressAuthConfig: '',
      generalAuthConfig: 'https://www.pittmeadows.ca/sites/default/files/2026-06/Consent-to-Disclosure-Form-v2.pdf',
      accessMethod: {
        digitalLabel: '($0.10/page)',
        physicalLabel: '($0.25/page)',
        otherActiveType: null
      },
      disclaimer: `Personal information is collected for the purposes of processing your request for records.
      The City is collecting this information under Section 26(c) of the Freedom of Information and
      Protection of Privacy Act. For questions regarding the collection of personal information on this
      form, please contact the Information and Privacy Team at clerks@pittmeadows.ca or (604) 465-5454.`
    }
  }
}

const saskatoonpirConfig = {
  supportPortal: false,
  showContact: false,
  city: 'Saskatoon',
  pir: {
    active: true,
    terminology: { ...saskatoonPirTerminology },
    paymentEnabled: false,
    fullName: 'Saskatoon',
    province: 'SK',
    supportEmail: 'building.standards@saskatoon.ca',
    supportPhone: '(306) 975-2645',
    ownerAuthForm:
      'https://www.saskatoon.ca/sites/default/files/documents/asset-financial-management/assessment-taxation/Owner%20Agent%20Authorization%20Form%202025.pdf',
    disclaimer: `A Building Permit Drawing Package is a process to provide copies of City documents and plans from the
    Building Standards Department regarding a specific property or properties. The City does not guarantee the
    availability of information for all files. <br/>
    This form may be submitted to request copies of records from the City’s Building Standards Department relating
    to a specific property or specific properties. The City does not guarantee the availability of information and
    may withhold records in accordance with applicable privacy and copyright legislation. <br/>
    Any information that may be provided will be provided in good faith and on an as-is basis. The City does not make
    any representations or warranties as to the accuracy, completeness, or timeliness of the information, or to its
    fitness for any particular purpose, or to it being free from viruses, worms or other manifestation in code or
    content that may contain destructive properties. The City does not accept any liability with respect to access to
    or use of the information. <br/>
    Information on this form is being collected in accordance with The Local Authority Freedom of Information and
    Protection of Privacy Act and will be used for the purposes of processing and responding to the applicant’s
    request for information.`,
    gis: {
      ownerVerification: false,
      addressVerification: false,
      strataVerification: false
    }
  },
  foi: { ...inactiveFoiConfig }
}

const saskatoonfoiConfig = {
  supportPortal: false,
  showContact: false,
  city: 'Saskatoon',
  pir: { ...inactivePirConfig },
  foi: {
    active: true,
    privacyTeamNumber: '(306) 975-3240',
    privacyTeamEmail: 'accessandprivacy@saskatoon.ca',
    address: 'City Hall\n222 3rd Avenue North\nSaskatoon, SK\nS7K 0J5',
    APPLICATION_FEE: true,
    applicationFeeAmount: 20,
    bill: {
      percentDue: {
        APPLICATION_FEE: 100,
        FEE_ESTIMATE: 50,
        INVOICE: 100
      }
    },
    request: {
      addressAuthConfig: '',
      generalAuthConfig: '',
      accessMethod: {
        digitalLabel: '',
        physicalLabel: '($0.25/page)',
        otherActiveType: {
          type: 'OTHER_PICKUP',
          label: 'USB',
          pricingDetails: '($10)'
        }
      },
      disclaimer: `We are authorized by Section 6(1)(a) of The Local Authority Freedom of Information and
      Protection of Privacy Act to ask for the information on this form. We will use this information to
      process your request. If we do not collect this information, we may not be able to process your request.`
    }
  }
}

export const configMapping = {
  citadel: { ...citadelConfig },
  citadelpir: { ...citadelpirConfig },
  citadelfoi: { ...citadelfoiConfig },
  kelownapir: { ...kelownaConfig },
  kamloopsfoi: { ...kamloopsConfig },
  pittmeadowspir: { ...pittmeadowsConfig },
  pittmeadowsfoi: { ...pittmeadowsfoiConfig },
  princegeorgefoi: { ...princegeorgeConfig },
  saskatoonfoi: { ...saskatoonfoiConfig },
  saskatoonpir: { ...saskatoonpirConfig }
}

export const config = configMapping[THEME]
